import React, { useState, useEffect } from 'react';
import { MaterialReactTable, useMaterialReactTable } from 'material-react-table';
import { Box, Button, IconButton, Switch, Tooltip, Typography, Skeleton } from '@mui/material';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import AddIcon from '@mui/icons-material/Add';

const DynamicTable = ({ data, onEditClick, onViewClick, loading }) => {
  const [tableData, setTableData] = useState(data);
  const [switchStates, setSwitchStates] = useState(data.map(() => false)); // Initialize switch states to false for each row

  useEffect(() => {
    setTableData(data);
    if (data.length > 0) {
      setSwitchStates(data.map(() => false)); // Reset switch states when data changes
    } else {
      setSwitchStates([]); // Initialize switch states with an empty array if data is empty
    }
  }, [data]);

  const handleChange = (rowIndex) => {
    alert(rowIndex);
    setSwitchStates((prevStates) => {
      const newStates = [...prevStates];
      newStates[rowIndex] = !newStates[rowIndex]; // Toggle the state of the clicked switch
      return newStates;
    });
  };

  const columns = React.useMemo(() => {
    if (tableData.length === 0) return [];
    const hasPasswordColumn = Object.keys(tableData[0]).includes('password');

    return [
     
      ...Object.keys(tableData[0]).map((header) => ({
        accessorKey: header,
        header: header.replace(/_/g, ' '),
        Cell: ({ row, rowIndex }) => row.original[header],
      })),
    ];
  }, [tableData, switchStates]);

  const table = useMaterialReactTable({
    columns,
    data: tableData,
    initialState: {
      density: 'compact',
      pagination: { pageSize: 10, pageIndex: 0, enableDensityToggle: true },
    },
    
  });

  const handleChangePassword = (rowData) => {
   
  };

  return (
    <div>
      {loading ? (
        <Box display="flex" justifyContent="center" alignItems="center" height={400}>
          <Skeleton variant="rectangular" width={300} height={100} animation="wave" />
          <Typography variant="body1" ml={2}>
            Loading...
          </Typography>
        </Box>
      ) : (
        <Box position="relative">
          <MaterialReactTable style={{ density: 'compact' }} table={table} />
        </Box>
      )}
    </div>
  )
}

export default DynamicTable
